export default "__VITE_ASSET__ClVBytQW__"